export const selectGovernmentList = (state) => state.governmentlists;
